/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input.mat-input-element[_ngcontent-%COMP%]{position:relative;top:3px;left:0}\n/*# sourceMappingURL=custom-date-picker.component.css.map*/"];
export { styles as styles };
